import { gql } from 'urql';
import { CharacterDetails } from '../fragments/character.graphql';

export const getCharacter = gql`
  query GetCharacter($playerId: Int!, $characterId: Int!) {
    user(userId: $playerId) {
      id
      fullName
      roleInOrganization
      userOrganization {
        id
        branch {
          id
          shorthand
        }
      }
      character(characterId: $characterId) {
        ...CharacterDetails
      }
    }
  }
  ${CharacterDetails}
`;

export const getCharacterXp = gql`
  query GetCharacterXp($playerId: Int!, $characterId: Int!) {
    user(userId: $playerId) {
      id
      character(characterId: $characterId) {
        id
        xpAudits {
          eventId
          eventName
          xpAwarded
          xpAddOn
          homeGameEventsIndex
          kind
          awardedAt
          branchTransferId
          originBranch
          destinationBranch
          extraBuildId
          applicableOn
        }
      }
    }
  }
`;

export const getCharacterLifecycles = gql`
  query GetCharacterLifecycles($playerId: Int!, $characterId: Int!) {
    user(userId: $playerId) {
      id
      character(characterId: $characterId) {
        id
        currentLife
        lifeCapacity
        lifeGain
        lifeLoss
        lifecycles {
          id
          kind
          description
          createdAt
          deletedAt

          event {
            id
            name
          }
        }
      }
    }
  }
`;

export const getCharacterRetirementPaths = gql`
  query GetCharacterRetirementPaths($playerId: Int!, $characterId: Int!) {
    user(userId: $playerId) {
      id
      character(characterId: $characterId) {
        id
        alive
        retirementPaths {
          alive {
            amount
            earnedOn
          }
          dead {
            amount
            earnedOn
          }
        }
      }
    }
  }
`;

export const getCharacterInventories = gql`
  query GetCharacterInventories($playerId: Int!, $characterId: Int!) {
    user(userId: $playerId) {
      id
      fullName
      character(characterId: $characterId) {
        id
        name
        inventories {
          itemId
          registeredItemId
          expiresAt
          expiresOn
          remainingUses
          stack
          stackPending
          item {
            id
            kind
            multipleUses
            numberOfUses
            name
          }
          registeredItem {
            id
            description
          }
        }
      }
    }
  }
`;

export const getCharacterItemTransactions = gql`
  query GetCharacterItemTransactions($playerId: Int!, $characterId: Int!, $itemId: Int!, $expiresAt: String) {
    user(userId: $playerId) {
      id
      character(characterId: $characterId) {
        id
        itemTransactions(itemId: $itemId, expiresAt: $expiresAt) {
          id
          stack
          status
          createdAt
          expiresAt
          expiresOn
          isMailout
          remainingUses
          event {
            id
            name
            branch {
              id
              name
              shorthand
            }
          }
          item {
            id
            name
            kind
            multipleUses
            numberOfUses
          }
          mod {
            id
            name
          }
          postie {
            id
            fullName
          }
          registeredItem {
            id
            description
          }
        }
      }
    }
  }
`;

export const getCharacterFellowshipsMissingSubpillar = gql`
  query GetCharacterFellowshipsMissingSubpillar($playerId: Int!, $characterId: Int!) {
    user(userId: $playerId) {
      id
      character(characterId: $characterId) {
        id
        fellowshipsMissingSubpillar {
          id
          name
        }
      }
    }
  }
`;

export const getItemTransactionUses = gql`
  query GetItemTransactionUses($playerId: Int!, $characterId: Int!, $itemTransactionId: Int!) {
    user(userId: $playerId) {
      id
      character(characterId: $characterId) {
        id
        itemTransaction(id: $itemTransactionId) {
          id
          itemTransactionUses {
            id
            use
            createdAt
            event {
              id
              name
            }
            postie {
              id
              fullName
            }
          }
        }
      }
    }
  }
`;
